module.exports = __webpack_public_path__ + "../resources/img/qr-android-home.9eabf872.png";